/*Tps-report*/
if (window.location.pathname.includes("reports/submitted-claims")) {
  const claimTypes = {
    hotel: "Hotel Only",
    housing: "Long Term Housing Only",
    full: "Hotel w/ Long Term Housing",
    frv: "Fair Rental Value Estimate"
  };

  $.each($(".data-table"), function() {
    $(this).data("options", window.app_data.datatableOptions);
  });

  $("[name='claim_search']").on("keyup", function() {
    let val = $(this).val();
    $.each($(".data-table"), function() {
      $(this)
        .DataTable()
        .search(val)
        .draw();
    });
  });

  $(".data-table").on("click", ".btn-approve", function(e) {
    const id = $(this).data("id");
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);

    Swal.fire({
      title: "Approve Claim",
      html: "Are you sure you want to approve this claim?",
      icon: undefined,
      showCancelButton: true,
      confirmButtonText: "Approve",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      preConfirm: async () => await approveClaim(id, table, tr)
    }).then(result => approvedClaimModal(result));
  });

  function approvedClaimModal(result) {
    if (!result.isConfirmed) return;

    if (result.value && result.value.placement && result.value.placement.id) {
      const placementId = result.value.placement.id;

      Swal.fire({
        title: "Approved",
        text: "Claim is approved.",
        icon: "success",
        showCancelButton: true,
        cancelButtonText: "Okay",
        confirmButtonText: "View Claim",
        reverseButtons: true,
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          window.location.href = `/placement/edit/${placementId}`;
        }
      });
    } else {
      Swal.fire("Approved", "Claim is approved.", "success");
    }
  }

  $(window).on("tableLoaded", async function(e, table) {
    if (!window.wp_id) return;

    const id = window.wp_id;
    const tr = $(`.btn-view[data-id="${id}"]`)
      .closest("tr")
      .get(0);

    if (!tr) return;

    const data = table
      .DataTable()
      .row(tr)
      .data();

    openDetailsModal(id, data, table, tr);
  });

  $(".data-table").on("click", ".btn-view", function(e) {
    const id = $(this).data("id");
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);
    const data = table
      .DataTable()
      .row(tr)
      .data();

    openDetailsModal(id, data, table, tr);
  });

  function openDetailsModal(id, data, table, tr) {
    if (!data) return;

    Swal.fire({
      title: "Claim Details",
      html: getClaimDetails(data),
      icon: undefined,
      showCancelButton: true,
      confirmButtonText: "Approve",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      width: 1024,
      preConfirm: async () => await approveClaim(id, table, tr)
    }).then(result => approvedClaimModal(result));
  }

  $(".data-table").on("click", ".btn-delete", function(e) {
    const id = $(this).data("id");
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);

    Swal.fire({
      title: "Delete Claim",
      html: "Are you sure you want to delete this claim?",
      icon: undefined,
      showCancelButton: true,
      showDenyButton: true,
      showConfirmButton: false,
      denyButtonText: "Delete",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      preDeny: async () => await deleteClaim(id, table, tr)
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "Claim is deleted.", "success");
      }
    });
  });

  async function approveClaim(id, table, tr) {
    try {
      const result = await new Promise((resolve, reject) => {
        $.ajax({
          url: `/api/submitted_claim/approve`,
          method: "POST",
          data: { id },
          dataType: "json",
          success: response => resolve(response),
          error: response => reject(response)
        });
      });

      table
        .DataTable()
        .row(tr)
        .remove()
        .draw();
      return result;
    } catch (e) {
      Swal.showValidationMessage(`There is something wrong!`);
      return false;
    }
  }

  async function deleteClaim(id, table, tr) {
    try {
      const result = await new Promise((resolve, reject) => {
        $.ajax({
          url: `/api/submitted_claim/delete/${id}`,
          method: "DELETE",
          dataType: "json",
          success: response => resolve(response),
          error: response => reject(response)
        });
      });

      table
        .DataTable()
        .row(tr)
        .remove()
        .draw();
      return result;
    } catch (e) {
      Swal.showValidationMessage(`There is something wrong!`);
      return false;
    }
  }

  function getClaimDetails(data) {
    return `<div class="row text-left">
        <div class="col col-md-6 mb-4">
            <h3>Adjuster Information</h3>
            <p class="mb-0"><strong>First Name:</strong> ${data.adjuster.first_name || "-"}</p>
            <p class="mb-0"><strong>Last Name:</strong> ${data.adjuster.last_name || "-"}</p>
            <p class="mb-0"><strong>Company:</strong> ${data.adjuster.company || "-"}</p>
            <p class="mb-0"><strong>Phone:</strong> ${data.adjuster.phone || "-"}</p>
            <p class="mb-0"><strong>Ext.:</strong> ${data.adjuster.ext || "-"}</p>
            <p class="mb-0"><strong>Email:</strong> ${data.adjuster.email || "-"}</p>
        </div>
        <div class="col col-md-6 mb-4">
            <h3>Claim Information</h3>
            <p class="mb-0"><strong>Claim Type:</strong> ${claimTypes[data.claim_type] || "-"}</p>
            <p class="mb-0"><strong>Claim Number:</strong> ${data.claim_number || "-"}</p>
            <p class="mb-0"><strong>Date of Loss:</strong> ${data.loss_date ? moment(data.loss_date).format("MM/DD/YYYY") : "-"}</p>
            <p class="mb-0"><strong>ALE Limit:</strong> ${data.ale_limit || "-"}</p>
            <p class="mb-0"><strong>Policy Type:</strong> ${data.policy_type || "-"}</p>
            <p class="mb-0"><strong>Type of Loss:</strong> ${data.loss_type || "-"}</p>
        </div>

        <div class="col col-md-6 mb-4">
            <h3>Policyholder Information</h3>
            <p class="mb-0"><strong>First Name:</strong> ${data.policyholder.first_name || "-"}</p>
            <p class="mb-0"><strong>Last Name:</strong> ${data.policyholder.last_name || "-"}</p>
            <p class="mb-0"><strong>Cell Phone:</strong> ${data.policyholder.phone || "-"}</p>
            <p class="mb-0"><strong>Alt Phone:</strong> ${data.policyholder.alt_phone || "-"}</p>
            <p class="mb-0"><strong>Email:</strong> ${data.policyholder.email || "-"}</p>
            <p class="mb-0"><strong>Address:</strong> ${data.policyholder.address.address || "-"}</p>
            <p class="mb-0"><strong>Address 2:</strong> ${data.policyholder.address.address_2 || "-"}</p>
            <p class="mb-0"><strong>City:</strong> ${data.policyholder.address.city || "-"}</p>
            <p class="mb-0"><strong>State:</strong> ${data.policyholder.address.state || "-"}</p>
            <p class="mb-0"><strong>Zip:</strong> ${data.policyholder.address.zip || "-"}</p>
        </div>

        <div class="col col-md-6 mb-4">
            <div class="row">
                <div class="col-12 mb-4">
                    <h3>Family Dynamics</h3>
                    <p class="mb-0"><strong># of Adults:</strong> ${data.dynamics.adults || "-"}</p>
                    <p class="mb-0"><strong># of Kids:</strong> ${data.dynamics.kids || "-"}</p>
                    <p class="mb-0"><strong>Has Pets:</strong> ${data.dynamics.has_pets || "-"}</p>
                    <p class="mb-0"><strong># of Pets:</strong> ${data.dynamics.pets || "-"}</p>
                    <p class="mb-0"><strong>Pet(s) Description:</strong> ${data.dynamics.pet_description || "-"}</p>
                </div>
                <div class="col-12 mb-4">
                    <h3>Approved Terms</h3>
                    <p class="mb-0"><strong>Monthly Budget:</strong> ${
                      isNaN(data.terms.monthly_budget) ? data.terms.monthly_budget || "unknown" : "$" + window.formatMoney(data.terms.monthly_budget)
                    }</p>
                    <p class="mb-0"><strong>Lease Length:</strong> ${data.terms.lease_length || "-"}</p>
                </div>
            </div>
        </div>

        <div class="col col-12 mb-4">
            <h3>Other considerations</h3>
            <p class="mb-0">${data.other_considerations || "-"}</p>
        </div>

        <div class="col col-12 mb-4">
            <small class="mb-0"><strong>Submitted Date: </strong>${data.submitted_at ? moment(data.submitted_at).format("MM/DD/YYYY hh:mm A") : "-"}</small>
        </div>
    </div>`;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/submitted-claims.js